import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CalendarDaysIcon, CalendarPlusIcon } from 'lucide-react';
import { election } from '../data/election';
import { useCountdown } from '../hooks/useCountdown';
import { openExternal } from '../utils/navigation';
export function CountdownBar() {
  const {
    days,
    hours,
    minutes,
    seconds,
    isOver
  } = useCountdown(election.startsAt);
  const units = [{
    label: 'Días',
    value: days
  }, {
    label: 'Horas',
    value: hours
  }, {
    label: 'Minutos',
    value: minutes
  }, {
    label: 'Segundos',
    value: seconds
  }];
  return <section aria-label="Cuenta regresiva para las elecciones" className="relative bg-primary text-white" data-id="element-244" data-mp="2cfxw50oeu711">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-8 px-6 py-10 lg:flex-row lg:justify-between lg:py-8" data-id="element-245" data-mp="28f47u6722q7m">
        <div className="flex flex-col items-center gap-5 sm:flex-row sm:gap-8" data-id="element-246" data-mp="ant8i1dy1vw4">
          <span className="text-sm font-bold uppercase tracking-[0.25em] text-accent-gold" data-id="element-247" data-mp="6mppx74ihlr7">
            {isOver ? '¡Hoy es el día!' : 'Faltan'}
          </span>
          <div className="flex items-center gap-3 sm:gap-5" role="timer" aria-live="off" data-id="element-248" data-mp="13gdcn5ythgus">
            {units.map((u, i) => <React.Fragment key={u.label} data-id="element-249" data-mp="udubqreldeb6" data-mpi={i}>
                <div className="flex w-14 flex-col items-center sm:w-16" data-id="element-250" data-mp="uex2mzbwzgr3">
                  <div className="relative h-11 w-full overflow-hidden sm:h-12" data-id="element-251" data-mp="yfz3fklhc0v6">
                    <AnimatePresence initial={false} mode="popLayout" data-id="element-252" data-mp="1m408gjjg8z5u">
                      <motion.span key={u.value} initial={{
                    y: '100%',
                    opacity: 0
                  }} animate={{
                    y: 0,
                    opacity: 1
                  }} exit={{
                    y: '-100%',
                    opacity: 0
                  }} transition={{
                    duration: 0.35,
                    ease: 'easeOut'
                  }} className="font-display absolute inset-0 text-center text-4xl font-bold tabular-nums leading-[1.2] sm:text-[44px]" data-id="element-253" data-mp="1m6utac6dklzs">
                        {String(u.value).padStart(2, '0')}
                      </motion.span>
                    </AnimatePresence>
                  </div>
                  <span className="mt-1 text-[11px] font-semibold uppercase tracking-widest text-white/60" data-id="element-254" data-mp="2fo82y5gz2ls4">
                    {u.label}
                  </span>
                </div>
                {i < units.length - 1 && <span aria-hidden className="mb-5 h-8 w-px bg-white/15" data-id="element-255" data-mp="25p8twlsaoo4l" />}
              </React.Fragment>)}
          </div>
        </div>

        <div className="flex flex-col items-center gap-4 sm:flex-row sm:gap-6" data-id="element-256" data-mp="20t1xpkppaqzu">
          <div className="flex items-center gap-4" data-id="element-257" data-mp="1vz7boammhzxl">
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-accent-gold" data-id="element-258" data-mp="1ry4040blyq26">
              <CalendarDaysIcon className="h-7 w-7 text-primary" data-id="element-259" data-mp="1n0vdnnjffzv4" />
            </span>
            <div className="text-center leading-tight sm:text-left" data-id="element-260" data-mp="1i0zafqik0cgm">
              <p className="font-display text-xl font-extrabold uppercase tracking-wide md:text-2xl" data-id="element-261" data-mp="1d1mp5a7bzdg5">{election.title}</p>
              <p className="mt-1 text-base font-bold text-accent-gold md:text-lg" data-id="element-262" data-mp="12y7liomlsovn">{election.dateLabel}</p>
            </div>
          </div>
          <button type="button" onClick={() => openExternal(election.calendarUrl)} className="inline-flex items-center gap-2 rounded-full bg-accent-gold px-7 py-3.5 text-base font-extrabold uppercase tracking-wide text-primary shadow-md transition hover:-translate-y-0.5 hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-263" data-mp="17v7rkzjgdrmr">
            <CalendarPlusIcon className="h-5 w-5" data-id="element-264" data-mp="p6t0ydd1sfmh" />
            Agéndalo
          </button>
        </div>
      </div>
    </section>;
}